






















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import HeadLable from '@/components/HeadLable/index.vue';
import ImageUpload from '@/components/ImgUpload/index.vue';
import { addLiveStreaming, queryGiftLiveStreaming, updateLiveStreaming } from '@/api/streaming.ts';
import { baseUrl } from '@/config.json';
import { getToken } from '@/utils/cookies';

@Component({
  name: 'addShop',
  components: {
    HeadLable,
    ImageUpload
  }
})
export default class extends Vue {
  private restKey: number = 0;
  private title = '新建赛事直播';
  private imageUrl: string = '';
  private actionType: string = '';
  private vueRest = '1';
  private dishFlavors: any[] = []; // 待上传详情照片的数据
  private list: any[] = []
  private titleId = ''
  private headers = {
    token: getToken()
  };
  private ruleForm = {
    image: '',
  };

  get rules() {
    return {
      image: {
        required: true,
        message: '封面照片不能为空'
      }
    };
  }

  created() {
    this.titleId = this.$route.query.titleId;
    this.actionType = this.$route.query.id ? 'edit' : 'add';
    if (this.$route.query.id) {
      this.title = '修改礼物信息';
      this.init();
    }
  }

  private async init() {
    queryGiftLiveStreaming(this.$route.query.id).then(res => {
      if (res && res.data && res.data.code === 1) {
        this.imageUrl = res.data.data.image;
        this.ruleForm = res.data.data;
        // this.ruleForm.image = res.data.data.image;
        this.list = res.data.data.list;
        // this.dishFlavors = res.data.data.list.map((item: any) => ({
        //   image: item.image || '' // 确保每个对象都有 image 属性，即使为空
        // }));
        // console.log(this.dishFlavors);
      } else {
        this.$message.error(res.data.msg);
      }
    });
  }

  private addFlavore() {
    this.dishFlavors.push({ image: '' });
  }

  private delFlavor(index: number) {
    this.dishFlavors.splice(index, 1);
  }

  private delList(index: number) {
    this.list.splice(index, 1);
  }

  private flavorImageChange(index: number, value: string) {
    this.dishFlavors[index].image = value;
    console.log(this.dishFlavors)
  }

  private submitForm(formName: any, st: any = false) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        if (!this.ruleForm.image) return this.$message.error('封面照片不能为空');
        if (this.dishFlavors.size < 1) return this.$message.error('详情照片不能为空');
        let params: any = { ...this.ruleForm };
        if (this.list && this.list.length >0) {
            params.list = [...this.list, ...this.dishFlavors.filter(item => item.image)]
          } else {
            params.list = this.dishFlavors.filter(item => item.image);
          }
        if (this.actionType === 'add') {
          params.titleId = this.titleId;
          delete params.id;
          addLiveStreaming(params)
            .then(res => {
              if (res.data.code === 1) {
                this.$message.success('赛事直播添加成功！');
                if (!st) {
                  this.$router.push({ path: '/competition/liveStreamingManage' });
                } else {
                  this.dishFlavors = [];
                  this.imageUrl = '';
                  this.ruleForm = {
                    image: '',
                  };
                  this.restKey++;
                }
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message);
            });
        } else {
          delete params.createTime;
          delete params.updateTime;
          updateLiveStreaming(params)
            .then(res => {
              if (res && res.data && res.data.code === 1) {
                this.$router.push({ path: '/competition/liveStreamingManage' });
                this.$message.success('赛事直播修改成功！');
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message);
            });
        }
      } else {
        return false;
      }
    });
  }

  imageChange(value: any) {
    this.ruleForm.image = value;
  }
}
